import request from '@/utils/request'

export function getClassData(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/queryMallStoreClass',
    method: 'post',
    params
  })
}
export function getAddData(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/addDemanderMallStoreClass',
    method: 'post',
    params
  })
}
export function getTreeData(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/getTree',
    method: 'post',
    params,
  })
}
export function getModData(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/editDemanderMallStoreClass',
    method: 'post',
    params,
  })
}
export function getConfirm(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/sureMallStoreClass',
    method: 'post',
    params,
  })
}
export function getDel(params) {
  return request({
    url: '/mall/storemanage/mallstoreclass/delMallStoreClass',
    method: 'post',
    params,
  })
  // centerDialogVisibleDel
}